<ng-container *ngIf="state === 'form'">
  <h2 mat-dialog-title class="reservation-dialog__title">
    Editar Número de Reserva
  </h2>

  <mat-dialog-content class="reservation-dialog__body">
    <p class="reservation-dialog__label">Ingrese el código de reserva:</p>

    <input
      class="reservation-dialog__input"
      [formControl]="codigoControl"
      type="text"
      placeholder="Código de reserva"
      autocomplete="off"
    />

    <p
      *ngIf="codigoControl.hasError('pattern') && codigoControl.touched"
      class="reservation-dialog__error"
    >
      El código solo puede contener letras, números y los caracteres:
      °!"#$%&/()=¿?¡!/*-+.
    </p>

    <p *ngIf="message" class="reservation-dialog__hint">{{ message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="reservation-dialog__actions">
    <button
      mat-flat-button
      class="buttonPrimary"
      (click)="saveReservaFx()"
      [disabled]="loader"
    >
      <mat-spinner *ngIf="loader" [diameter]="18"></mat-spinner>
      <span *ngIf="!loader">Guardar</span>
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="state === 'error'">
  <h2 mat-dialog-title class="reservation-dialog__title">
    {{ errorTitle || 'No se pudo actualizar' }}
  </h2>

  <mat-dialog-content class="reservation-dialog__body">
    <p class="reservation-dialog__error">{{ errorMessage }}</p>
    <p class="reservation-dialog__hint">
      La grilla puede estar desactualizada. Al continuar se consultará de nuevo el backend.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="reservation-dialog__actions">
    <button
      mat-flat-button
      class="buttonPrimary"
      (click)="cerrarYActualizar()"
    >
      Entendido y actualizar
    </button>
  </mat-dialog-actions>
</ng-container>
